export default [
  {
    path: "/copilot",
    name: "copilot",
    component: () => import("@/page/copilot/index.vue"),
    meta: {
      title: "copilot"
    },
    children: [
      {
        path: "/",
        name: "copilot-index",
        component: () => import("@/page/copilot/index/index.vue"),
        meta: { title: "小PAI Copilot" }
      },
      {
        path: "intelligent",
        name: "intelligent",
        component: () => import("@/page/copilot/intelligent/index.vue"),
        meta: { title: "智能问答" }
      },
      {
        path: "selectReport",
        name: "selectReport",
        component: () => import("@/page/copilot/selectReport/index.vue"),
        meta: { title: "选择研报" }
      },
      {
        path: "analysis",
        name: "analysis",
        component: () => import("@/page/copilot/analysis/index.vue"),
        meta: { title: "研报解析" }
      },
      {
        path: "multiModel",
        name: "multiModel",
        component: () => import("@/page/copilot/multiModel/index.vue"),
        meta: { title: "AI多模型讨论" }
      },
      {
        path: "agentAggregation",
        name: "agentAggregation",
        component: () => import("@/page/copilot/agentAggregation/index.vue")
      },
      {
        path: "createdIntelligentAgent",
        name: "createdIntelligentAgent",
        component: () =>
          import("@/page/copilot/createdIntelligentAgent/index.vue")
      },
      {
        path: "settingIntelligentAgent",
        name: "settingIntelligentAgent",
        component: () =>
          import("@/page/copilot/createdIntelligentAgent/setting.vue")
      },
      {
        path: "createdSuccessfully",
        name: "createdSuccessfully",
        component: () =>
          import("@/page/copilot/createdIntelligentAgent/successfully.vue")
      },
      {
        path: "guideIntelligentAgent",
        name: "guideIntelligentAgent",
        component: () =>
          import("@/page/copilot/createdIntelligentAgent/guide.vue")
      },
      {
        path: "userIntelligentAgent",
        name: "userIntelligentAgent",
        component: () => import("@/page/copilot/userIntelligentAgent/index.vue")
      },
      {
        path: "userKnowledgeBase",
        name: "userKnowledgeBase",
        component: () => import("@/page/copilot/userKnowledgeBase/index.vue")
      },
      {
        path: "editKnowledgeBase",
        name: "editKnowledgeBase",
        component: () =>
          import("@/page/copilot/userKnowledgeBase/add-edit-base.vue")
      },
      {
        path: "guideKnowledgeBase",
        name: "guideKnowledgeBase",
        component: () => import("@/page/copilot/userKnowledgeBase/guide.vue")
      },
      {
        path: "userChat",
        name: "userChat",
        component: () => import("@/page/copilot/userChat/index.vue")
      },
      {
        path: "userBusinessCard",
        name: "userBusinessCard",
        component: () => import("@/page/copilot/userChat/business-card.vue")
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/copilot.js